'use client';
import { cn } from '@module/lib/utils';
import type React from 'react';

interface BaseSpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: number;
}

function BaseSpinner({ size = 40, className, ...rest }: BaseSpinnerProps) {
  return (
    <div
      style={{ width: size, height: size }}
      className={cn(`animate-spin rounded-full border-4 border-gray-200 border-t-4 border-t-[#152348]`, className)}
      {...rest}
    />
  );
}

export default BaseSpinner;
